// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import { setHasOpened } from './setHasOpened.tsx';
import type { State } from './State.types.tsx';

const actions = { setHasOpened } as const;

type Actions = typeof actions;

const initialState = {
	hasOpened: false,
} as const;

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'jsw-onboarding-quickstart-has-opened',
});

export const useHasOpened: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly setHasOpened: () => Action<State>;
		}
	>,
	void
> = createHook(Store);
